import {
  FETCH_CONSTRAINTS_PENDING,
  FETCH_CONSTRAINTS_REJECTED,
  FETCH_CONSTRAINTS_FULFILLED,
} from "../../constants/constraints";

const constraints = (state = {}, action) => {
  switch (action.type) {
    case FETCH_CONSTRAINTS_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case FETCH_CONSTRAINTS_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case FETCH_CONSTRAINTS_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action.payload.data,
      };
    default:
      return state;
  }
};
export default constraints;
